import { usePermissionCheck } from 'src/hooks/permission-check.hook';

import { IPermissionCheck } from './permission-check.interfaces';

const PermissionCheck = ({ permission, children, action: actions }: IPermissionCheck) => {
  const { checkRule } = usePermissionCheck(permission);

  return <>{checkRule(actions) && children}</>;
};

export default PermissionCheck;
